import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import useTable from "../../../useTable";
//UI
import { DangerButton, SuccessButton } from '../../../../ui/buttons/Button'
import { Dimmer } from "../../../spinner";
import { Mensaje, MensajeSiNo } from "../../../mensajes2";
import { SearchInput } from "../../../../ui/inputs/Input";
import axios from "axios";
import { selectClasses } from "@mui/material";

const headCells = [
    {
        id: "codigo",
        backgroundColor: "rgba(5, 81, 130, 1)",
        color: "#ffffff",
        label: "Código",
        textAlign: "center",
    },
    {
        id: "nombre",
        backgroundColor: "rgba(5, 81, 130, 1)",
        color: "#ffffff",
        label: "Nombre",
        textAlign: "center",
    },
    {
        id: "proper",
        backgroundColor: "rgba(5, 81, 130, 1)",
        color: "#ffffff",
        label: "Periodo Actual",
        textAlign: "center",
    },
    {
        id: "anioCurso",
        backgroundColor: "rgba(5, 81, 130, 1)",
        color: "#ffffff",
        label: "Año en Curso",
        textAlign: "center",
    },
    {
        id: "procesando",
        backgroundColor: "rgba(5, 81, 130, 1)",
        color: "#ffffff",
        label: "Procesando",
        textAlign: "center",
    },
];

export default function SeleccionarOtroPago(props) {
    const nominaSel = JSON.parse(localStorage.getItem('codigonomina'));
    let op = require("../../../../../src/modulos/datos");
    let token = localStorage.getItem('jwtToken');
    const [records, setRecords] = useState([]);
    const [activate, setActivate] = useState(false);
    const [activo, setActivo] = useState(true);
    const [select, setSelect] = useState(false);
    const [values, setValues] = useState({});
    const [itemSelect, setItemSelect] = useState(-1);

    const [filterFn, setFilterFn] = useState({ fn: (items) => { return items; }, });
    const [mensaje, setMensaje] = useState({
        mostrar: false,
        titulo: "",
        texto: "",
        icono: "",
    });
    const [mensajesino, setMensajesino] = useState({
        mostrar: false,
        titulo: "",
        texto: "",
        icono: "",
    });

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTable(records, headCells, filterFn);

    const salir = () => {
        blanquear();
        props.onHideCancela('');
    };

    const handleSearch = (e) => {
        let target = e.target;

        setFilterFn({
            fn: (items) => {
                if (target.value === "") {
                    return items;
                } else {
                    //alert(JSON.stringify(items))
                    return items.filter((x) => {
                        //alert(JSON.stringify(x.codnomi) + "     " + JSON.stringify(x.titnomi) + "     " + JSON.stringify(x.proximo));
                        if (
                            (x.codotropago.toLowerCase().includes(target.value.toLowerCase()) === null
                                ? ""
                                : x.codotropago.toLowerCase().includes(target.value.toLowerCase())) ||

                            (x.descripago.toLowerCase().includes(target.value.toLowerCase()) === null
                                ? ""
                                : x.descripago.toLowerCase().includes(target.value.toLowerCase())) ||
                            (x.proper === null
                                ? ""
                                : x.proper.toString().includes(target.value)) ||
                            (x.aniocurso === null
                                ? ""
                                : x.aniocurso.toString().includes(target.value)) ||
                            ((x.procesando === true ? "SI" : "NO").includes(target.value))
                        ) {
                            return x;
                        }
                    });
                }
            },
        });
    };

    const seleccionarOtrosPagos = () => {
        setActivate(true);
        let campos = "*"
        let nomtab = "nomi" + nominaSel + ".otrospagos";
        let orden = "codotropago";

        let endpoint = op.conexion + `/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {
            if (response.status == 200) {
                setActivate(false);
                setRecords(response.data);
            }
        }).catch(function (error) {
            setMensaje({
                mostrar: true,
                titulo: "ERROR",
                texto: error.response.data.message,
                icono: "error",
            });
            setActivate(false);
            //props.onHideCancela(error.response.data.message);
        })
    }

    const blanquear = () => {
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
        setItemSelect("");
        setActivate(false);
        setRecords([]);
        setActivo(true);
        setFilterFn({ fn: items => { return items; } });
    }
    const cancelar = () => {
        blanquear();
        if (props.onHideCancelar) props.onHideCancelar();
        if (props.setShow) props.setShow(false);
    }

    const cerrarModal = () => {
        if (props.onHideCancelar) { props.onHideCancelar(); }
        if (props.setShow) props.setShow(false);

        blanquear()
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
    }

    const seleccionarOtroPago = (event) => {
        event.preventDefault();
        if (values[0].procesando === false) {
            //seleccionarPeriodo(values[0].codigonomina, values[0].numperiodo);
            setMensajesino({
                mostrar: true,
                titulo: "Confirmación.",
                texto: "Desea Activar Los Conceptos del Último Pago Guardado?",
                icono: "confirmacion",
            });
        } else {
            var codigootropago = values[0].codigootropago;;
            var titulotropago = values[0].titulotropago;

            localStorage.setItem('codigootropago', JSON.stringify(codigootropago));
            localStorage.setItem('titulotropago', JSON.stringify(titulotropago));

            props.onHideCancela('');
        }

    };

    const seleccionarFila = (index) => (event) => {
        setItemSelect(index);
        setActivo(false);
        setSelect(parseInt(nominaSel));
        var codigootropago = recordsAfterPagingAndSorting()[index].codotropago;;
        var titulotropago = recordsAfterPagingAndSorting()[index].descripago;
        var procesando = recordsAfterPagingAndSorting()[index].procesando;

        var datos = [];
        datos.push({
            codigootropago,
            titulotropago,
            procesando
        })
        setValues(datos);
    };

    const seleccionarPeriodo = (activar) => {
        setActivate(true);
        let body = {
            activar: activar,
            codnomina: nominaSel,
            codpago: values[0].codigootropago
        };
        let endpoint = `${op.conexion}/api/nomina/actualizarseleccionarotropago`;
		axios
			.post(endpoint, body, {
				headers: {
					"x-access-token": `${token}`,
					"Content-Type": "application/json",
				},
		}).then(function (response) {
            if (response.status == 200) {

                var codigootropago = values[0].codigootropago;;
                var titulotropago = values[0].titulotropago;

                localStorage.setItem('codigootropago', JSON.stringify(codigootropago));
                localStorage.setItem('titulotropago', JSON.stringify(titulotropago));

                props.onHideCancela('');

            }
            setActivate(false)
        }).catch(function (error) {
            setMensaje({
                mostrar: true,
                titulo: "ERROR",
                texto: error.response.data.message,
                icono: "error",
            });
            setActivate(false)
        })
    }

    const handleCloseSi = () => {
        setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
        seleccionarPeriodo(true);
        
    };

    return <Modal
        size="lg"
        {...props}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
        backdrop="static"
        keyboard={false}
        onShow={() => {
            seleccionarOtrosPagos();
            setSelect(nominaSel)
        }}
    >
        <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top azulGradiant">
            <h3 className="fw-bold m-0">Seleccionar Nómina</h3>
            <a type="button" className="fw-bold text-light fs-6" onClick={salir}>
                Salir <i className="fa fa-times ms-2"></i>
            </a>
        </Modal.Header>
        <Modal.Body className="col-12 m-0 p-2 d-flex flex-wrap">
            <Dimmer active={activate} inverted>

            </Dimmer>
            <div className="col-6 input-group input-group-sm m-0 mb-2 p-0">
                <input type='text' placeholder="Buscar"
                    onChange={handleSearch} className="form-control search-input rounded-pill" />
            </div>
            <div className="col-12 m-0 p-0">
                <TblContainer>
                    <TblHead />
                    <tbody>
                        {records &&
                            recordsAfterPagingAndSorting().map((item, index) => (
                                <tr key={item.codotropago} style={{ padding: "0", cursor: 'pointer', backgroundColor: select === parseInt(item.codnomi) ? "lightskyblue" : itemSelect === index ? "lightskyblue" : "white" }} onClick={seleccionarFila(index)}>
                                    <td className='py-2 text-center'>{item.codotropago}</td>
                                    <td className='py-2 text-start'>{item.descripago}</td>
                                    <td className='py-2 text-center'>{item.proper}</td>
                                    <td className='py-2 text-center'>{item.aniocurso}</td>
                                    <td className='py-2 text-center'>{item.procesando === true ? "SI" : "NO"}</td>
                                </tr>
                            ))}
                    </tbody>
                </TblContainer>
                <TblPagination />
            </div>
        </Modal.Body>
        <Modal.Footer>
            <SuccessButton onClick={seleccionarOtroPago} disabled={activo}>
                Aceptar
            </SuccessButton>
            <DangerButton onClick={salir}>
                Cancelar
            </DangerButton>
        </Modal.Footer>
        <Mensaje
            mensaje={mensaje}
            onHide={() => {
                setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
                
            }}
        />
        <MensajeSiNo
            mensaje={mensajesino}
            onHideNo={() => {
                setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
                seleccionarPeriodo(false);
            }}
            onHideSi={handleCloseSi}
        />
    </Modal>
}